import styled from 'styled-components';

export const HighlightedName = styled.span<{
  $active: boolean;
}>`
  ${({ $active }) => $active && 'background: rgb(255, 237, 184);'}
`;
